<template>
  <div class="quote-tab">
    <h1>Support Tickets</h1>
    <div class="filter-container">
      <div class="filter-box">
        <span class="label">
          Filter by Type
          <!-- <span class="all">Select All</span> -->
        </span>
        <v-radio-group
          v-model="type"
          :borderBlock="true"
          :list="ticketTypeOptions"/>
      </div>
      <div
        v-if="selectionTickets.length>0"
        class="text-right">
        <v-button
          @click="handlerClearSelection">Clear Selection</v-button>
        <v-button
          type="danger"
          @click="handlerSelected('unsnooze')">Unsnooze Now</v-button>
        <v-button
          type="success"
          @click="handlerSelected('resolved')">Mark As Resolved</v-button>
        <!-- <v-button
          type="info"
          :disabled="true">Merge as New Ticket</v-button> -->
      </div>
    </div>
    <!-- <div class="transparent">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        style="width: 100%"
        class="table-pointer"
        @row-click="routerToTicket"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"></el-table-column>
        <el-table-column
          prop="subject"
          label="Subject"></el-table-column>
        <el-table-column
          prop="assignee"
          label="Assigned To"></el-table-column>
        <el-table-column
          prop="created_at"
          label="Created On"></el-table-column>
        <el-table-column
          prop="stauts_language"
          label="Status"></el-table-column>
        <el-table-column
          width="120"
          label="Type">
          <template slot-scope="scope">
            <span class="span-checkbox">{{ scope.row.type_language }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div> -->

    <!-- <list-table
      :tableData="tableData"
      @rowClick="routerToTicket"
      @selectionChange="handleSelectionChange"></list-table> -->
    <ticket-table
      :customerId="customerId"
      :is-fina="isFina"
      :otherData="{type}"></ticket-table>
    <!-- <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" /> -->
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import { setResolvedTicket, setTicketUnsnooze, getAllTicketList } from '@/api/ticket'
// import ListTable from '@/views/tickets/components/list-table.vue'
import TicketTable from '@/views/components/ticket-table'
import { mapState } from 'vuex'
export default {
  name: 'TicketsTab',
  components:{
    // ListTable,
    TicketTable
  },
  mixins: [MixinOptions],
  props: {
    // customerId: [String, Number]
  },
  inject:['customer_id','merchant_platform'],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      type: 0,
      tableData: [],
      selectionTickets: []
    }
  },
  computed:{
    ...mapState('account', ['customerFilter']),
    customerId(){
      return this.customer_id()
    },
    isFina(){
      let merchant_platform = this.merchant_platform()
      return merchant_platform ==2
    },
  },
  watch:{
  },
  created() {
  },
  methods: {

    handleSelectionChange(val) {
      this.selectionTickets = val
    },
    handlerClearSelection() {
      this.$refs.table.clearSelection()
    },
    routerToTicket({ id }) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: id
        }
      })
    },
    handlerSelected(type) {
      if(this.selectionTickets.length < 1) {
        this.$message({
          type: 'warning',
          message: 'Please Select'
        })
        return
      }
      const ticketId = this.selectionTickets.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(type === 'resolved') {
        this.network().setResolvedTicket(ticketId)
      } else {
        this.network().setTicketUnsnooze(ticketId)
      }
    },
    network() {
      return {
        setResolvedTicket: async (ticketId) => {
          const { data } = await setResolvedTicket({
            ticket_id: ticketId
          })
          this.network().getAccountTicketList()
        },
        setTicketUnsnooze: async (ticketId) => {
          const { data } = await setTicketUnsnooze({
            ticket_id: ticketId
          })
          this.network().getAccountTicketList()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-tab {
    position: relative;
    h1 {
        padding-bottom: 15px;
        color: #616266;
        font-size: 20px;
    }
    .top-right {
        position: absolute;
        top: 0;
        right: 0;
    }
    .filter-container {
      .filter-box {
          margin-bottom: 10px;
          .label {
              display: block;
              padding-bottom: 5px;
              font-size: 14px;
              font-weight: bold;
              .all {
                  display: inline-block;
                  padding-left: 15px;
                  color: #409EFF;
                  font-weight: 400;
                  font-weight: 500;
              }
          }
          .search-box {
              width: 400px;
          }
          .quote-box {
              width: 300px;
          }
      }
      .text-right{
        position: absolute;
        z-index: 100;
        right: 5px;
        margin-top: 6px;
        //margin-right: 15px;
        height: 40px;
        width: 90%;
        background-color:#F6F8FA !important;
      }
    }
}
.v-radio-group{
  /deep/.el-radio{
    margin-right: 30px !important;
  }
}
</style>
